import { render, staticRenderFns } from "./DebitNotes.vue?vue&type=template&id=20065bef&scoped=true"
import script from "./DebitNotes.vue?vue&type=script&lang=js"
export * from "./DebitNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20065bef",
  null
  
)

export default component.exports